__turbopack_context__.v({
  "arrow": "Popover-module__uonoRa__arrow",
  "popoverContainer": "Popover-module__uonoRa__popoverContainer",
});
